import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import {
  Field,
  Form,
  Formik,
} from 'formik';
import {
  Row,
  Col,
  ControlLabel,
  FormGroup,
  FormControl,
  Alert,
  Button,
  InputGroup,
} from 'react-bootstrap';
import LoadingButton from '../../components/LoadingButton/LoadingButton';
import {
  Portlet,
  PortletBody,
  PortletCaption,
  PortletTitle,
} from '../../components/Bootstrap/Portlet';
import { Dropdown } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

@inject('dischargeStore', 'scheduleStore', 'mixStore')
@observer
class TruckChargeForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  initialValues = () => {
    return {
      truckId: null,
      dischargeSequenceId: null,
      rate: null,
      driverId: null,
    };
  };

  render() {
    const { dischargeStore, mixStore, t } = this.props;
    const { truckChargeId, truckCharge, sequences } = dischargeStore;
    const { drivers, trucks } = this.props.scheduleStore;
    const truckOptions = mixStore.getOptions(trucks, {
      key: 'id',
      text: ['code', 'description'],
      value: ['id'],
      subheader: 'code',
      description: 'description',
    });

    const onCancel = () => {
      dischargeStore.selectTruckCharge();
    };

    return (
      <Portlet>
        <PortletTitle>
          <PortletCaption>{truckChargeId > 0 ? t('Edit Truck Charge', {truckChargeId}) : t('New Truck Charge')}</PortletCaption>
        </PortletTitle>
        <PortletBody>
          <Formik
            enableReinitialize
            initialValues={
              truckChargeId > 0
                ? truckCharge.find(v => v.id === truckChargeId)
                : this.initialValues()
            }
            onSubmit={(values, actions) => {
              this.setState({
                error: null,
              });

              let promise;
              if (values.id > 0) {
                promise = dischargeStore.updateTruckCharge(values);
              } else {
                promise = dischargeStore.addTruckCharge(values);
              }

              promise.then(() => {
                actions.setSubmitting(false);
                dischargeStore.selectTruckCharge();
              }).catch(e => {
                actions.setSubmitting(false);
                this.setState({
                  error: `${e.message}`,
                });
              });

            }
            }
          >{({ handleChange,
              values,
              setFieldValue,
              isSubmitting,
            }) => (
              <Form className={'truck-charge-form'}>
                <Row>
                  <Col sm={3} md={6}>
                    <FormGroup>
                      <ControlLabel>{t('Truck')}</ControlLabel>
                      <Dropdown onChange={(e, data) => setFieldValue('truckId', data.value)}
                        value={values.truckId || ''}
                        fluid search selection options={truckOptions} />
                    </FormGroup>
                  </Col>
                  <Col sm={3} md={6}>
                    <FormGroup>
                      <ControlLabel>{t('Sequence')}</ControlLabel>
                      <FormControl
                        name="dischargeSequenceId"
                        componentClass="select"
                        value={values.dischargeSequenceId || ''}
                        onChange={handleChange}
                        bsSize="sm"
                      >
                        <option value="" />
                        {sequences.map(option => (
                          <option key={option.id} value={option.id}>
                            {option.name ? `${option.name}` : `#${option.id}`}
                          </option>
                        ))}
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col sm={3} md={6}>
                    <FormGroup>
                      <ControlLabel>{t('Default Rate')}</ControlLabel>
                      <InputGroup>
                        <Field name="rate"
                          type="number"
                          value={values.rate || ''}
                          onChange={handleChange}
                          className="form-control input-sm" />
                        <InputGroup.Addon>{t('unit')} / {t('sec')}</InputGroup.Addon>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col sm={3} md={6}>
                    <FormGroup>
                      <ControlLabel>{t('Driver')}</ControlLabel>
                      <FormControl
                        name="driverId"
                        componentClass="select"
                        value={values.driverId || ''}
                        onChange={handleChange}
                        bsSize="sm"
                      >
                        <option value="" />
                        {drivers.map(option => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col sm={12} className="text-right">
                    {!!this.state.error && <Alert bsStyle="danger">{this.state.error}</Alert>}
                    <Button onClick={onCancel}>{t('Cancel')}</Button>
                    {' '}
                    <LoadingButton
                      bsStyle="primary"
                      type="submit"
                      label={t('Save')}
                      loadingLabel={t('Saving')}
                      isLoading={isSubmitting}
                    />
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </PortletBody>
      </Portlet>
    );
  }
}

export default withTranslation()(TruckChargeForm);
